<template>
  <div class="layers">
    <div class="layer-btn-close-area" @click="$emit('show', false)">
    </div>

    <div v-if="page === 'choices'" class="mybox choices">
      <div v-if="!room.frozen">
        <div class="absorb">
          <div class="ui-title center-h">
            Absorb Cell?
          </div>

          <!-- <pre>{{ room }}</pre> -->
          <!-- <p> -->
            <!-- This will consume 1 action point. -->
          <!-- </p> -->
          <div class="center-h">
            <button class="maibutton yes" @click="() => { page = 'quitz'; $emit('show', true); }">Yes</button>
            <button class="maibutton no" @click="() => { $emit('show', false); }">No</button>
          </div>
        </div>
      </div>
      <div v-if="room.frozen">
        <div class="absorb">
          <div class="ui-title center-h">
            Room is Frozen
          </div>
        </div>
      </div>
    </div>

    <div v-if="page === 'quitz'" class="myquitzbox">
      <Answering ref="answering" @close="close" v-if="questionID" :currentLevel="currentLevel" :isRed="correct" :questionID="questionID" @show="(v) => { $emit('show', v); }" @right="(v) => { onRightAns(v) }" @wrong="(v) => { onWrongAns(v) }">
      </Answering>
    </div>

    <div v-if="page === 'correct'" class="mybox">
      <div>
        <div class="absorb correct">
          <div class="ui-title center-h">
            Correct
          </div>
          <!-- <p> -->
            <!-- This will consume 1 action point. -->
          <!-- </p> -->
        </div>
      </div>
    </div>
    <div v-if="page === 'incorrect'" class="mybox">
      <div>
        <div class="absorb incorrect">
          <div class="ui-title center-h">
            Incorrect
          </div>
          <!-- <p> -->
            <!-- This will consume 1 action point. -->
          <!-- </p> -->
        </div>
      </div>
    </div>

    <div class="layer-btn-close" @click="$emit('show', false)">
      <img src="./close.svg" alt="">
    </div>
  </div>
</template>

<script>
import Answering from '../apps-yoqb/teacher/Answering.vue'
import * as Analytics from '@/api/analytics.js'
import * as Folder from '@/api/folders.js'
import * as Question from '@/api/question.js'
import * as Sound from '@/audio.js'
export default {
  props: {
    myInfo: {},
    room: {},
    players: {},
    currentClicked: {},
    activeTiles: {}
  },
  components: {
    Answering
  },
  data () {
    return {
      questionToAskStudent: false,
      openDate: new Date(),
      currentLevel: '',
      result: false,
      page: 'choices',
      correct: false,
      autoclose: true,
      questionID: false,

      cellState: {},

      actionType: 'captureEmptyCell',
      // captureEmptyCell, captureOwnedCell, captureCellCore
    }
  },
  async mounted () {
    Sound.absorb.play()
    require('@/game/apps-yoqb/compos/MyScript.vue').default.preload()

    // const hastagR = require('hashtag-regex')
    let easy = String(this.room.easyQuestion).trim() //.match(hastagR())
    let medium = String(this.room.mediumQuestion).trim() //.match(hastagR())
    let hard = String(this.room.hardQuestion).trim() //.match(hastagR())

    console.log('room, easy medium hard')
    console.log(this.room, easy, medium, hard)

    console.log('current clicked brick')
    console.log(this.currentClicked.brick)

    console.log('this players')
    console.log(this.players)

    this.$emit('show', true)
    let toUse = hard
    if (this.players.some(p => p.gameInfo.cellCore.numID === this.currentClicked.numID)) {
      toUse = hard
      this.currentLevel = 'hard'
      try {
        this.actionType = 'captureCellCore'
        this.cellState = this.players.find(p => p.gameInfo.cellCore.numID === this.currentClicked.numID).gameInfo.cellCore
      } catch (e) {
        console.log(e)
      }
    } else if (this.activeTiles.some(a => a.numID === this.currentClicked.brick.numID)) {
      toUse = medium
      this.currentLevel = 'medium'
      try {
        this.actionType = 'captureOwnedCell'
        this.cellState = this.activeTiles.find(a => a.numID === this.currentClicked.brick.numID)
      } catch (e) {
        console.log(e)
      }
    } else {
      // let levels = [easy, medium, hard]
      // let idx = Math.floor(Math.random() * levels.length)
      // let currentLevel = ['easy', 'medium', 'hard']
      // this.currentLevel = currentLevel[idx]
      // let rand = levels[idx]
      this.currentLevel = 'easy'
      try {
        this.actionType = 'captureEmptyCell'
        this.cellState = this.currentClicked.brick
      } catch (e) {
        console.log(e)
      }
      toUse = easy
    }
    this.tagOfQuestion = toUse
    let resp = await Folder.matchFolderTags({
      tags: toUse
    })

    let folders = resp.data
    let randomFolder = folders[Math.floor(Math.random() * folders.length)]
    if (randomFolder) {
      let randomFolderID = randomFolder._id
      let questionResp = await Question.getRandomQuestion({ folderID: randomFolderID })

      // this.questionResp
      //
      this.questionToAskStudent = questionResp.data
      this.openDate = new Date()
      if (questionResp) {
        this.questionID = questionResp.data._id
      }
    }
  },
  methods: {
    collectResp ({ resp, correct }) {
      let now = new Date()
      let currentCell = JSON.parse(JSON.stringify(this.currentClicked))
      console.log(this.room)
      let record = Analytics.collectResp({
        roomName: this.room.title,
        roomSize: `${this.room.sizeX}x${this.room.sizeY}`,
        displayName: this.myInfo.displayName,
        userID: this.myInfo.userID,
        gameID: this.room.roomID,
        resp: resp,
        question: this.questionToAskStudent.document,
        takeHowLongToAns: now.getTime() - this.openDate.getTime(),
        correct: correct,
        ansDate: now,
        full: resp.markFull,
        mark: resp.mark,
        userType: 'firebase',
        gameType: 'cell-game',
        questionBankFolderTagName: this.tagOfQuestion,
        questionBankFolderID: this.questionToAskStudent.folderID,
        questionBankQuestionID: this.questionToAskStudent._id,
        questionType: this.questionToAskStudent.document.ansType,
        levelOfQuestion: this.currentLevel,
        actionType: this.actionType,
        cellState: this.cellState,
        cellID: currentCell.numID
      })
      /*
      yo-analytics-post
      */
    },
    onRightAns (v) {
      Sound.correct.play()
      this.correct = true
      this.result = true
      this.collectResp({ resp: v, correct: true })

      this.$emit('correct', this.correct)
      this.page = 'correct'
      setTimeout(() => {
        this.$emit('show', false)
        this.$forceUpdate()
      }, 2000)
    },
    onWrongAns (v) {
      Sound.error.play()
      this.correct = false
      this.result = true
      this.collectResp({ resp: v, correct: false })

      this.$emit('correct', this.correct)
      console.log(this.$refs['answering'].$refs['bordercolor'].classList.add('isRed'))

      this.$forceUpdate()

    },
    close () {
      this.$emit('show', false)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.layers{
  width: 100%;
  height: 100%;
  position: relative;
}
.layer-close-clicker{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.layer-quiz{
  position: absolute;
  top: 10px;
  left: 10px;
  width: calc(100% - 10px - 10px);
  height: calc(100% - 10px - 10px);
}

.pieceofpaper{
  background-color: rgba(255, 255, 255, 0.842);
  /* min-height: calc(100vh - 7vmin - 7vmin); */
  height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
}

.pieceofpaper{
  display: flex;
  justify-content: center;
}

.pieceofpaper.quitz{
  background-color: rgba(255,255,255,0.9);
}

.mybox{
  transform: translateY(30px);
  width: 100%;
  padding: 1px;
}

.ui-title{
  font-size: 30px;
  margin-bottom: 10px;
}

.center-h{
  width: 100%;
  display: flex;
  justify-content: center;
}

.maibutton {
  display: inline-block;
	box-shadow:inset 0px 1px 0px 0px #ffffff;
	background-color:#f9f9f9;
	border-radius: 13px;
	border:1px solid #dcdcdc;
	display:inline-block;
	cursor:pointer;
	color:#797575;
	font-family:Arial;
	font-size:20px;
	font-weight:bold;
	padding:15px 24px;
	text-decoration:none;
	text-shadow:0px 1px 0px #ffffff;
}
.maibutton:hover {
	background-color:#e9e9e9;
}
.maibutton:active {
	position:relative;
	top:1px;
}
.maibutton:disabled {
	background-color:#cccccc;
}
.layer-btn-close{
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 30px;
  background-color: rgba(255, 255, 255, 0.726);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.absorb{
  font-weight: bold;
  padding: 20px;
  background-color: #f9f9f9;
  max-width: 600px;
  margin: 20px auto;
  border: #1B1464 solid 5px;
  border-radius: 30px;
  box-shadow: 0px 0px 30px 0px #f9f9f9;
}
.absorb.correct{
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #39B54A;
  color: #39B54A;
  min-height: 300px;
}
.absorb.incorrect{
  display: flex;
  justify-content: center;
  align-items: center;

  border-color: red;
  min-height: 300px;
  color: red;
}
.maibutton{
  margin: 20px;
}
.maibutton.yes{
  border-width: 3px;
  border-color: #39B54A;
  box-shadow: 0px 0px 10px #39B54A;
}
.maibutton.no{
  border-width: 3px;
  border-color: red;
  box-shadow: 0px 0px 10px red;
}
.layer-btn-close-area{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

</style>
